import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";

import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { LocalDataService } from "../../../../../../modules/shared/services/local-data.service";
@Component({
    selector: "grouping-customize-display",
    templateUrl: "./grouping-customize-display.view.html",
    providers: []
})
export class GroupingCustomizeDisplaySectionView implements OnInit {
    levels: any = ["topLevel"];
    constructor(public sharedService: SharedService, private localDataService: LocalDataService) {}
    ngOnInit() {}
}
